var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6860_37)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.9214 9.46875L26.5407 23.8495C24.9372 25.4489 22.7648 26.3471 20.5 26.3471C18.2352 26.3471 16.0628 25.4489 14.4593 23.8495L0.0785833 9.46875C0.0546667 9.73867 0 9.98296 0 10.2512V30.7512C0.00271259 33.0157 0.903507 35.1868 2.50479 36.788C4.10608 38.3893 6.27711 39.2901 8.54167 39.2928H32.4583C34.7229 39.2901 36.8939 38.3893 38.4952 36.788C40.0965 35.1868 40.9973 33.0157 41 30.7512V10.2512C41 9.98296 40.9453 9.73867 40.9214 9.46875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1251 21.4354L39.729 5.82973C38.9731 4.57636 37.907 3.53892 36.6335 2.81748C35.3599 2.09604 33.922 1.71494 32.4583 1.71094H8.54166C7.078 1.71494 5.64006 2.09604 4.36654 2.81748C3.09302 3.53892 2.0269 4.57636 1.271 5.82973L16.8749 21.4354C17.8377 22.3943 19.1412 22.9327 20.5 22.9327C21.8588 22.9327 23.1623 22.3943 24.1251 21.4354Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6860_37"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 41,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.4742a52a394b2fbae125e0554d267675.svg";
export { ForwardRef as ReactComponent };